import styled from 'styled-components';

import Icon from 'components/Icon';
import { selected, gray } from '../../utils/style/colors';

interface WithColor {
  noColor?: boolean;
}
interface ICollapsibleHeaderProps extends WithColor {
  contentColor?: string;
  backgroundColor?: string;
  isOpen: boolean;
  bordered: boolean;
}

interface ICollapsibleTitleIconProps {
  color: string;
}

interface ICollapsibleContainerProps extends WithColor {
  bordered: boolean;
  noZ: boolean;
}

interface IHorizontalCollapsibleContainerProps extends WithColor {
  isOpen: boolean;
  noZ: boolean;
}

const BORDER_COLOR = gray;

export const CollapsibleContainer = styled.div<ICollapsibleContainerProps>`
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
  border: ${(props) =>
    props.bordered && !props.noColor ? `1px solid ${BORDER_COLOR}` : 'unset'};
  border-radius: 10px;
  transition: box-shadow 0.25s;
  background-color: ${(props) =>
    props.noColor ? 'undefined' : 'var(--exact-white)'};
  ${(props) => (props.noZ ? '' : 'z-index: 1;')} // position: relative;
  overflow: hidden;
`;

export const HorizontalCollapsibleContainer = styled.div<IHorizontalCollapsibleContainerProps>`
  display: flex;
  flex-direction: row;
  //border: 1px solid ${selected};
  border-radius: 2rem;
  padding: 0.5rem 0;
  background-color: ${(props) =>
    props.isOpen ? selected : 'var(--exact-white)'};
`;

export const CollapsibleHeader = styled('div')<ICollapsibleHeaderProps>`
  position: sticky;
  top: 0;
  z-index: 99;
  padding: ${(props) => props.headerWrapperPadding || '0.5rem'};
  display: flex;
  border-radius: 7px;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background-color: ${(props) =>
    props.noColor ? undefined : props.backgroundColor};
  color: ${(props) => (props.noColor ? undefined : props.contentColor)};
  transition: all 0.3s;
  border-bottom: ${(props) =>
    props.noColor
      ? undefined
      : props.bordered
        ? `1px solid ${props.backgroundColor}`
        : 'unset'};
  & > div {
    display: flex;
    align-items: center;
  }

  ${({ isOpen, bordered, noColor }) => {
    if (isOpen) {
      if (bordered && !noColor) {
        return `
            border-bottom-left-radius: 0px;
            border-bottom-right-radius: 0px;
        `;
      } else {
        return `
            border-bottom-left-radius: 0px;
            border-bottom-right-radius: 0px;`;
      }
    }
    return undefined;
  }}
`;

export const HorizontalCollapsibleHeader = styled(
  'div'
)<ICollapsibleHeaderProps>`
  position: sticky;
  top: 0;
  z-index: 99;
  display: flex;
  border-radius: 1rem;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background-color: ${(props) =>
    props.noColor ? undefined : props.backgroundColor};
  color: ${(props) => (props.noColor ? undefined : props.contentColor)};
`;

export const CollapsibleTitleIcon = styled(Icon)<ICollapsibleTitleIconProps>`
  color: ${(props) => props.color};
  margin-inline-end: 1rem;
`;
export const DayRow = styled('div')`
  padding: 7px 0;
  display: flex;
  align-items: center;
`;
export const DayRowTitle = styled('div')`
  width: 110px;
  text-align: center;
`;
export const DayRowHoursSection = styled('div')`
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;
export const DayRowHours = styled('div')<WithColor>`
  display: flex;
  align-items: center;
  padding: 7px 14px;
  border: ${({ noColor }) => (noColor ? undefined : '1px solid black')};
  border-radius: ${({ noColor }) => (noColor ? undefined : '5px')};
  margin-right: 10px;
  margin-top: 4px;
  margin-bottom: 4px;
`;
export const DayRowHoursText = styled('div')`
  text-align: center;
`;
export const DayRowGetHours = styled('div')``;
export const DaySelectSection = styled('div')`
  display: flex;
  align-items: center;
`;
